module.exports = __webpack_public_path__ + "img/id3.f8f82080.png";